
import { Card, CardContent } from "@/components/ui/card";

const TestimonialsSection = () => {
  const testimonials = [
    {
      quote: "ScoutLink.ai saved us 80+ hours of VC research. We closed our seed round 3 months faster.",
      author: "Sarah Chen",
      company: "TechStars NYC '23",
      role: "Co-founder"
    },
    {
      quote: "The AI matching was incredible - we found VCs we never would have discovered manually.",
      author: "Marcus Rodriguez",
      company: "Y Combinator W23",
      role: "CEO"
    },
    {
      quote: "Finally, a tool that understands the startup fundraising process. Game changer.",
      author: "Emily Watson",
      company: "500 Global",
      role: "Founder"
    }
  ];

  return (
    <section className="container mx-auto px-6 py-20 bg-white/50 backdrop-blur">
      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">Trusted by Accelerator Alumni</h2>
        <p className="text-xl text-gray-600">See how ScoutLink.ai has helped startups close their rounds faster</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {testimonials.map((testimonial, index) => (
          <Card key={index} className="text-center">
            <CardContent className="pt-6">
              <p className="text-gray-600 mb-4 italic">"{testimonial.quote}"</p>
              <div>
                <div className="font-semibold">{testimonial.author}</div>
                <div className="text-sm text-gray-500">{testimonial.role}</div>
                <div className="text-sm text-blue-600">{testimonial.company}</div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};

export default TestimonialsSection;
